import { lazy } from 'react';

import { Route, Routes } from '@app/components/RouterProvider';

const EmailSignupPage = lazy(() => import('../../pages/SignupEmailSignupStep'));
const UserDetailsPage = lazy(() => import('../../pages/SignupUserDetailsStep'));

const SignupRouter = () => (
    <Routes>
        <Route path="signup">
            <Route path="" element={<EmailSignupPage />} />
            <Route path="details" element={<UserDetailsPage />} />
            <Route path="*" element={<EmailSignupPage />} />
        </Route>
    </Routes>
);

export default SignupRouter;
